import LiquidIf from './liquid-if';

export default class LiquidUnlessComponent extends LiquidIf {
  helperName = 'liquid-unless';
  inverted = true;
}
